(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function cocomiiStartWhenIdle(fn) {
      if (document.readyState === 'complete') { fn(); return; }
      window.addEventListener('load', fn, { once: true });
    }

    function hydrate(video) {
      if (video.dataset.cocomiiHydrated === 'true') return;
      video.dataset.cocomiiHydrated = 'true';
      cocomiiStartWhenIdle(function () { hydrateNow(video); });
    }

    function hydrateNow(video) {
      video.src = video.dataset.deferredSrc;
      video.removeAttribute('data-deferred-src');
      video.load();

      var parent = video.closest('.video-parent-section');

      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var saveData = navigator.connection && navigator.connection.saveData;
      if (reducedMotion || saveData) {
        video.controls = false;
        if (parent) parent.classList.add('video-interactable');
        return;
      }

      var play = video.play();
      if (play !== undefined) {
        play.catch(function () {
          video.controls = false;
          if (parent) parent.classList.add('video-interactable');
        });
      }
    }

    function observe(root) {
      var videos = root.querySelectorAll('video[data-deferred-src]:not([data-cocomii-observed])');
      videos.forEach(function (video) {
        video.dataset.cocomiiObserved = 'true';
        if (!('IntersectionObserver' in window)) {
          hydrate(video);
          return;
        }
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            observer.disconnect();
            hydrate(video);
          });
        }, { rootMargin: '200px 0px' });
        observer.observe(video);
      });
    }

    function init() {
      observe(document);
    }

    function schedule() {
      if (window.Shopify && Shopify.designMode) {
        init();
      } else if ('requestIdleCallback' in window) {
        requestIdleCallback(init, { timeout: 1200 });
      } else {
        setTimeout(init, 300);
      }
    }

    if (document.readyState === 'complete') schedule();
    else window.addEventListener('load', schedule, { once: true });

    document.addEventListener('shopify:section:load', function (event) {
      observe(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
